<template>
  <div id="doc-viewer">
    <vue-pdf-app
      v-if="pdf"
      @pages-rendered="pagesRenderedHandler"
      style="height: 94vh; flex: 1; margin: 1%;"
      :pdf="pdf"
      :config="config"
      :fileName="title"
      :title="true"
    ></vue-pdf-app>
  </div>
</template>
<script>
import scroll from "../directives/scroll";
import "vue-pdf-app-with-sign/dist/icons/main.css";

export default {
  name: "VDocument",

  directives: {
    scroll,
  },

  data() {
    return {
      searchController: null,
      pdf: null,
      pageCount: null,
      page: null,
      pageRotateCw: true,
      config: {
        secondaryToolbar: {
          firstPage: false,
          lastPage: false,
          cursorHandTool: false,
          scrollVertical: false,
          scrollHorizontal: false,
          scrollWrapped: false,
          spreadNone: false,
          spreadOdd: false,
          spreadEven: false,
          documentProperties: false,
          cursorSelectTool: false,
          pageRotateCw: true,
          pageRotateCcw: true
        },
        toolbar: {
          toolbarViewerRight: {
            openFile: false,
            download: false,
            print: false,
            viewBookmark: false
          },
        }
      }
    };
  },
  watch: {
    url: {
      handler(url) {
        this.startDoc(url);
      },
    },
    canPrint: {
      handler() {
        this.config.toolbar.toolbarViewerRight.print = false;
      }
    },
  },
  props: {
    url: String,
    isPublic: Boolean,
    canPrint: Boolean,
    ownerRevision: Boolean,
    canDownload: Boolean,
    title: String
  },

  methods: {
    startDoc(url) {
      console.log('VDocument startDoc: url received, length:', url.length);
      this.pdf = this.base64toURLBlob(url);
      console.log('VDocument: pdf set to blob');
    },
    base64toURLBlob(b64Data) {
      var byteCharacters = Buffer.from(b64Data, "base64");
      var uint8Array = new Uint8Array(byteCharacters.length);
      for (var i = 0; i < uint8Array.length; i++) {
        uint8Array[i] = byteCharacters[i];
      }

      return uint8Array.buffer;
    },

    pagesRenderedHandler(pdfApp) {
      console.log('VDocument: pages rendered, setting scale to 1');
      setTimeout(() => {
        pdfApp.pdfViewer.currentScaleValue = 1;
        console.log('VDocument: scale set to 1');

        const container = document.getElementById('doc-viewer');
        if (container) {
          container.addEventListener('click', (e) => {
            const anchor = e.target.closest('a[href]');
            if (!anchor) return;

            const href = anchor.getAttribute('href');
            if (!href || href.startsWith('#')) return;

            try {
              const parsed = new URL(href);
              const isDigitaldocLink = parsed.host.includes('digitaldoc');

              if (isDigitaldocLink && parsed.host !== window.location.host) {
                e.preventDefault();
                e.stopPropagation();
                const fixedUrl = `${window.location.origin}${parsed.pathname}${parsed.hash}`;
                window.location.href = fixedUrl;
              }
            } catch {
              // URL relativa, ignora
            }
          }, true);
        }
      });
    },
  },
};
</script>

<style scoped>
#doc-viewer {
  position: absolute;
  top: 5em;
  right: 0;
  bottom: 0;
  left: 0;
  outline: none;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>